/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Alert } from '@mui/material';
import FlagIcon from '@mui/icons-material/Flag';
import { FC } from 'react';

interface PatientTagBannerProps {
  tag?: string | null;
}

const bannerStyles = css`
  margin-bottom: 16px;

  .MuiAlert-icon {
    align-items: center;
  }

  .MuiAlert-message {
    font-size: 14px;
    font-weight: 500;
    white-space: pre-wrap;
  }
`;

export const PatientTagBanner: FC<PatientTagBannerProps> = ({ tag }) => {
  if (!tag?.trim()) {
    return null;
  }

  return (
    <Alert severity="warning" icon={<FlagIcon />} css={bannerStyles}>
      <strong>Patient was tagged</strong>
      {' '}
      {tag}
    </Alert>
  );
};

export default PatientTagBanner;
